var map = {
	"./arrow-down-blue.svg": 167,
	"./arrow-down-grey.svg": 168,
	"./arrow-right-white.png": 169,
	"./arrow-right.svg": 170,
	"./blue-loader.svg": 171,
	"./bnb.svg": 172,
	"./circle-grey.svg": 173,
	"./circle.svg": 174,
	"./coinbaseWalletIcon.svg": 69,
	"./dropdown-blue.svg": 175,
	"./dropdown.svg": 176,
	"./dropup-blue.svg": 177,
	"./ethereum-logo.png": 178,
	"./fortmaticIcon.png": 179,
	"./link.svg": 180,
	"./magnifying-glass.svg": 181,
	"./menu.svg": 182,
	"./metamask.png": 86,
	"./plus-blue.svg": 183,
	"./plus-grey.svg": 184,
	"./portisIcon.png": 185,
	"./question-mark.svg": 186,
	"./question.svg": 187,
	"./spinner.svg": 188,
	"./token-list/lists-dark.png": 189,
	"./token-list/lists-light.png": 190,
	"./trustWallet.png": 191,
	"./walletConnectIcon.svg": 70,
	"./x.svg": 192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;